import React, { useState } from 'react';
import { oneKlicks } from '../../SDK/oneclick';
import { toast } from 'react-toastify';


const BreakTimeModal = ({ isOpen, onClose, appointment, refresh }) => {
    console.log('appointment BreakTimeModal', appointment);
    const [breakTimeData, setBreakTimeData] = useState({
        breakType: '',
        fromTime: '',
        toTime: '',
        select_date: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBreakTimeData({ ...breakTimeData, [name]: value });
    };

    const validateTimeRange = () => {
        if (!appointment || !appointment.start_time || !appointment.end_time) {
            toast.error('Appointment time information is missing');
            return false;
        }

        const appointmentStart = new Date(`2000-01-01T${appointment.start_time}`);
        const appointmentEnd = new Date(`2000-01-01T${appointment.end_time}`);
        const breakStart = new Date(`2000-01-01T${breakTimeData.fromTime}`);
        const breakEnd = new Date(`2000-01-01T${breakTimeData.toTime}`);

        if (breakStart < appointmentStart || breakEnd > appointmentEnd) {
            toast.error('Break time must be between appointment start and end time');
            return false;
        }

        if (breakStart >= breakEnd) {
            toast.error('Break end time must be after break start time');
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (breakTimeData.breakType === 'some_time' && !validateTimeRange()) {
            return;
        }

        const tableSchema = '';
        const tableName = 'doctor_break_time';
        const data = {
            break_type: breakTimeData.breakType,
            from_time: breakTimeData.fromTime,
            to_time: breakTimeData.toTime,
            select_date: breakTimeData.select_date,
            hospital_id: appointment.hospital_id,
            doctor_id: appointment.doctor_id,
            appointment_setting_id: appointment.id,
            status: 'active'
        };
        const conditions = {};

        const responce = await oneKlicks.create(tableSchema, tableName, data, conditions);
        if (responce.success) {
            toast.success('Break time added successfully');
            onClose();
            refresh();
        } else {
            toast.error('Failed to add break time');
        }
    };

    // Helper to convert 1000/1700 to '10:00'/'17:00'
    const formatTime = (time) => {
        if (!time) return '';
        let str = time.toString().padStart(4, '0');
        const hours = str.slice(0, 2);
        const minutes = str.slice(2, 4);
        return `${hours}:${minutes}`;
    };

    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                position: 'relative',
                width: '90%',
                maxWidth: '500px'
            }}>
                <h2>Break Time</h2>
                
                <form onSubmit={handleSubmit} style={{ display: 'grid' }}>
                    <div style={{ marginBottom: '15px' }}>
                        <label htmlFor="select_date">Select Date</label>
                        <input
                            type="date"
                            id="select_date"
                            name="select_date"
                            value={breakTimeData.select_date}
                            onChange={handleChange}
                            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                            required
                        />
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label htmlFor="breakType">Break Type</label>
                        <select
                            id="breakType"
                            name="breakType"
                            value={breakTimeData.breakType}
                            onChange={handleChange}
                            style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                            required
                        >
                            <option value="">Select Break Type</option>
                            <option value="full_day">Full Day</option>
                            <option value="some_time">Some Time</option>
                        </select>
                    </div>
                    {breakTimeData.breakType === "some_time" && (
                        <p>
                            Appointment Time: {formatTime(appointment.start_time)} - {formatTime(appointment.end_time)} <br></br>
                            Please select the break time between the appointment time.
                        </p>
                    )}

                    {breakTimeData.breakType === "some_time" && (
                        <>
                            
                            <div style={{ marginLeft: '0px', marginRight: '0px', display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ marginBottom: '15px', width: '48%' }}>
                                    <label htmlFor="fromTime">From Time</label>
                                    <input
                                        type="time"
                                        id="fromTime"
                                        name="fromTime"
                                        value={breakTimeData.fromTime}
                                        onChange={handleChange}
                                        style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                                        required
                                        min={formatTime(appointment?.start_time)}
                                        max={formatTime(appointment?.end_time)}
                                        disabled={!appointment?.start_time || !appointment?.end_time}
                                    />
                                </div>

                                <div style={{ marginBottom: '15px', width: '48%' }}>
                                    <label htmlFor="toTime">To Time</label>
                                    <input
                                        type="time"
                                        id="toTime"
                                        name="toTime"
                                        value={breakTimeData.toTime}
                                        onChange={handleChange}
                                        style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                                        required
                                        min={breakTimeData.fromTime || formatTime(appointment?.start_time)}
                                        max={formatTime(appointment?.end_time)}
                                        disabled={!breakTimeData.fromTime || !appointment?.end_time}
                                    />
                                </div>
                            </div>

                        </>
                    )}


                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <button
                            type="button"
                            onClick={onClose}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#f0f0f0',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BreakTimeModal;
